import React from 'react';
import styled from 'styled-components';
import GroupFilter from './Group';
import ProjectFilter from './Project';
import AssigneeFilter from './Assignee';

export default function () {
  return (
    <Container>
      <GroupFilter />
      <ProjectFilter />
      <AssigneeFilter />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: space-between;
`;
